import { render, staticRenderFns } from "./MemberActivityDetails.vue?vue&type=template&id=c5204a68&scoped=true&"
import script from "./MemberActivityDetails.vue?vue&type=script&lang=js&"
export * from "./MemberActivityDetails.vue?vue&type=script&lang=js&"
import style0 from "./MemberActivityDetails.vue?vue&type=style&index=0&id=c5204a68&prod&scoped=true&lang=css&"
import style1 from "./MemberActivityDetails.vue?vue&type=style&index=1&id=c5204a68&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c5204a68",
  null
  
)

export default component.exports